// noinspection SpellCheckingInspection

import React, { useEffect, useState } from 'react';
import styles from './Instructions.module.css';
import newReservationScreenshot from '../../assets/images/new_reservation.png'
import addedScreenshot from '../../assets/images/added.png'
import viewReservationsScreenshot from '../../assets/images/status.png'
import paymentScreenshot from '../../assets/images/payment.png'
import redirectToMemberFeeButtonScreenshot from '../../assets/images/redirectToMemberFeeButton.png'
import memberFeeFormScreenshot from '../../assets/images/memberFeeForm.png'
import memberFeePayedScreenshot from '../../assets/images/memberFeePayd.png'
import feeForNonMemberScreenshot from '../../assets/images/nmenber.png'
import equipmentCornerScreenshot from '../../assets/images/equipmentCornerScreenshot.JPG'

const Instructions = () => {

    const [showScrollButton, setShowScrollButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollButton(window.scrollY > 300);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    return (
        <div className={styles.instructionsContainer}>
            <h1>Instrukcja użytkownika</h1>

            <nav className={styles.toc} aria-label="Spis treści">
                <h2>Spis treści</h2>
                <ul>
                    <li><a href="#rejestracja">1. Rejestracja</a></li>
                    <li><a href="#rezerwacja">2. Dodanie rezerwacji</a></li>
                    <li><a href="#anulowanie">3. Anulowanie rezerwacji</a></li>
                    <li><a href="#platnosci">4. Płatności</a></li>
                    <li><a href="#skladki">5. Składki członkowskie</a></li>
                    <li><a href="#statusy">6. Statusy rezerwacji</a></li>
                    <li><a href="#kod">7. Kod do drzwi</a></li>
                    <li><a href="#equipmentCorner">8. Wypożyczenie rakiet i piłek</a></li>
                    <li><a href="#selfService">9. Samoobsługa na korcie — zasady</a></li>
                </ul>
            </nav>

            <section className={styles.instructionText}>
                <h2 id="rejestracja">1. Rejestracja</h2>
                <p>📝 Aby zarezerwować kort, potrzebujesz <strong>konta użytkownika</strong>.</p>
                <ul>
                    <li>▶ Wybierz <strong>„Zarejestruj się"</strong> w formularzu logowania.</li>
                    <li>▶ Uzupełnij dane i potwierdź e-mail (link aktywacyjny ważny 24 h).</li>
                    <li>▶ Adres e-mail służy do logowania i odzyskiwania hasła.</li>
                </ul>
                <p>❗ Podanie nieprawdziwych danych może skutkować zawieszeniem konta.</p>
            </section>

            <section className={styles.instructionText}>
                <h2 id="rezerwacja">2. Dodanie nowej rezerwacji</h2>

                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={newReservationScreenshot} alt="Siatka rezerwacji z czerwonymi i jasnymi polami"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <ul>
                            <li>🟥 <strong>Czerwone pola</strong> — zajęte.</li>
                            <li>⬜ <strong>Jasne pola</strong> — dostępne.</li>
                            <li>▶ Kliknij, aby zaznaczyć (<strong>niebieski</strong>), zatwierdź <strong>„Rezerwuj"</strong> — pole zmieni się na <strong>zielony</strong>.</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={addedScreenshot} alt="Komunikat o dodanej rezerwacji"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <p>❗ Rezerwacji nie dodasz, jeśli masz zaległe płatności.</p>
                    </div>
                </div>
            </section>

            <section className={styles.instructionText}>
                <h2 id="anulowanie">3. Anulowanie rezerwacji</h2>
                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={viewReservationsScreenshot} alt="Przegląd zielonych komórek z własnymi rezerwacjami"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <ul>
                            <li>🟩 Zielone komórki to Twoje rezerwacje.</li>
                            <li>▶ Anulować możesz do momentu rozpoczęcia gry — przyciskiem <strong>„X"</strong> w zakładce „Rezerwacje" lub klikając w komórkę.</li>
                        </ul>
                        <p>❗ Administrator może anulować rezerwację — sprawdź e-mail przed grą.</p>
                    </div>
                </div>
            </section>

            <section className={styles.instructionText}>
                <h2 id="platnosci">4. Płatności</h2>
                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={paymentScreenshot} alt="Zakładka Płatności z przyciskiem Płacę"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <ul>
                            <li>💳 Płatność możliwa od momentu rozpoczęcia rezerwacji.</li>
                            <li>✅ Nieanulowana rezerwacja = obowiązek zapłaty.</li>
                            <li>▶ Kliknij <strong>„Płacę"</strong>, wybierz metodę (np. BLIK), potwierdź w systemie Przelewy24.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className={styles.instructionText}>
                <h2 id="skladki">5. Składki członkowskie</h2>

                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={redirectToMemberFeeButtonScreenshot} alt="Przycisk Chcę opłacić składkę BTT w zakładce Płatności"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <p>🤝 Krok 1 — Kliknij <strong>„Chcę opłacić składkę BTT"</strong> w zakładce „Płatności".</p>
                    </div>
                </div>

                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={memberFeeFormScreenshot} alt="Formularz wyboru wariantu składki członkowskiej"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <p>📋 Krok 2 — Wybierz wariant i zaakceptuj statut. Opłacenie składki = członkostwo BTT.</p>
                    </div>
                </div>

                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={memberFeePayedScreenshot} alt="Potwierdzenie opłaconej składki"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <p>✅ Po opłaceniu — brak opłat za korty przy grze z innymi członkami BTT.</p>
                    </div>
                </div>

                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={feeForNonMemberScreenshot} alt="Opcja dopłaty za gracza spoza BTT"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <p>⚠️ Grasz z osobą spoza BTT? Zaznacz <strong>„Dopłata za gracza spoza BTT"</strong> — 50 % stawki godzinowej.</p>
                    </div>
                </div>
            </section>

            <section className={styles.instructionText}>
                <h2 id="statusy">6. Statusy rezerwacji</h2>
                <ul>
                    <li>📝 <b>REG</b> — zarejestrowana, do zapłaty</li>
                    <li>✅ <b>PAY</b> — opłacona</li>
                    <li>❌ <b>CAN</b> — anulowana (brak obowiązku zapłaty)</li>
                    <li>🏅 <b>MEM</b> — w ramach składki członkowskiej BTT</li>
                    <li>💸 <b>NME</b> — z dopłatą za gracza spoza BTT (do zapłaty)</li>
                    <li>🎾 <b>LIG</b> — mecz ligowy</li>
                </ul>
            </section>

            <section className={styles.instructionText}>
                <h2 id="kod">7. Kod do drzwi</h2>

                <p>
                    Do otwarcia drzwi budynku klubowego służy <strong>zamek cyfrowy</strong> przy wejściu.
                    Należy użyć <strong>indywidualnego, niepowtarzalnego kodu</strong> przypisanego do Twojego konta.
                    Po wejściu zadbaj o bezpieczeństwo rzeczy w budynku, a po grze
                    <strong> upewnij się, że drzwi zostały zatrzaśnięte</strong>.
                </p>

                <p>Obsługa zamka:</p>
                <ul>
                    <li>▶ Wprowadź kod i zatwierdź przyciskiem <strong>#</strong></li>
                    <li>▶ Aby skasować ostatnią cyfrę — użyj <strong>*</strong></li>
                </ul>

                <p>
                    🔐 Każdy gracz ma <strong>indywidualny kod dostępu</strong>. Znajdziesz go po zalogowaniu w zakładce <strong>Profil &gt; Dane</strong>.
                </p>

                <ul>
                    <li>🟢 <strong>Kody członków BTT</strong> są zawsze aktywne.</li>
                    <li>🕒 <strong>Kody pozostałych użytkowników</strong> działają od <strong>10 minut przed</strong> rezerwacją do <strong>10 minut po</strong> jej zakończeniu.</li>
                </ul>

                <p>
                    Po wejściu na swój profil sprawdzany jest aktualny status Twojego kodu.
                    Po wyglądzie pola w profilu od razu rozpoznasz, czy w danym momencie kod otworzy drzwi:
                </p>

                <div className={styles.doorCodeStates}>
                    <figure>
                        <img
                            src="/door-code-active.jpg"
                            alt="Kod aktywny — niebieska wyraźna ramka"
                            className={styles.doorCodeImg}
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                        />
                        <figcaption>
                            ✅ <strong>Aktywny</strong> — wyraźna niebieska ramka, kod gotowy do użycia.
                        </figcaption>
                    </figure>
                    <figure>
                        <img
                            src="/door-code-inactive.jpg"
                            alt="Kod nieaktywny — wyszarzony, etykieta NIEAKTYWNY"
                            className={styles.doorCodeImg}
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                        />
                        <figcaption>
                            ⚪ <strong>Nieaktywny</strong> — wyszarzony, z plakietką „NIEAKTYWNY".
                            Brak aktywnej rezerwacji, członkostwa lub zaakceptowanego meczu ligowego —
                            kod w tej chwili nie otworzy drzwi.
                        </figcaption>
                    </figure>
                </div>

                <ul>
                    <li>❗ <strong>Nie udostępniaj swojego kodu</strong> innym osobom — jest przypisany wyłącznie do Twojego konta.</li>
                    <li>⛔ <strong>Po 3 błędnych próbach</strong> wprowadzenia kodu następuje czasowa blokada systemu na <strong>5 minut</strong>.</li>
                    <li>✉️ Jeśli chcesz zmienić kod lub masz pytania, napisz do: <a href="mailto:admin@btt.org.pl"><strong>admin@btt.org.pl</strong></a></li>
                </ul>
            </section>

            <section className={styles.instructionText}>
                <h2 id="equipmentCorner">8. Wypożyczenie rakiet i piłek</h2>

                <div className={styles.mediaRow}>
                    <figure className={styles.media}>
                        <img src={equipmentCornerScreenshot} alt="Kącik z rakietami i piłkami w klubie BTT"/>
                    </figure>
                    <div className={styles.mediaText}>
                        <p>
                            W budynku klubowym znajduje się <strong>kącik z rakietami i piłkami</strong>,
                            które można <strong>bezpłatnie wypożyczać</strong> na czas gry.
                        </p>
                        <ul>
                            <li>✅ Sprzęt jest dostępny wyłącznie dla osób z aktywną rezerwacją kortu w BTT.</li>
                            <li>✅ Wypożyczenie samoobsługowe — dostęp przez <strong>indywidualny kod do drzwi</strong> (zob. <a href="#kod">sekcja 7</a>).</li>
                            <li>✅ Rakiety podzielone na wieszaki dla <strong>dorosłych</strong> i <strong>dzieci</strong>. Po grze odłóż sprzęt na właściwe miejsce.</li>
                            <li>❗ Sprzętu nie należy zabierać do domu.</li>
                            <li>ℹ️ Sprzęt nie jest nowy — idealnie sprawdzi się dla osób rozpoczynających przygodę z tenisem.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className={styles.instructionText}>
                <h2 id="selfService">9. Samoobsługa na korcie — zasady</h2>
                <p>
                    Korty BTT funkcjonują w formule <strong>samoobsługowej</strong>. Każdy użytkownik
                    odpowiada za przygotowanie i pozostawienie kortu w odpowiednim stanie. Zasady te są
                    szczególnie ważne dla nowych graczy.
                </p>

                <ul className={styles.rulesList}>
                    <li>
                        <strong>💧 Polewanie kortu:</strong> W ciepłe dni (gdy kort jest suchy) <strong>obowiązkowo polewamy kort wodą</strong> — przed grą, w razie potrzeby w trakcie, oraz po. Niedopuszczalne jest siatkowanie, gdy unoszą się kłęby mączki. Dyszę kieruj <strong>w górę</strong>; strumień skierowany w dół może uszkodzić nawierzchnię.
                    </li>
                    <li>
                        <strong>🔐 Bezpieczeństwo budynku:</strong> Po wejściu indywidualnym kodem zadbaj o rzeczy w środku, a po grze upewnij się, że <strong>drzwi są zatrzaśnięte</strong> (zob. <a href="#kod">sekcja 7</a>).
                    </li>
                    <li>
                        <strong>🗑️ Porządek:</strong> Nie zostawiaj śmieci na korcie — zabierz je ze sobą.
                    </li>
                    <li>
                        <strong>🎾 Siatkowanie:</strong> Po grze <strong>zasiatkuj kort</strong>. <a href="https://www.youtube.com/shorts/RWvcP2KylrY" target="_blank" rel="noopener noreferrer">▶ Film instruktażowy</a>
                    </li>
                </ul>

                <p>🎾 Dziękujemy za dbałość o kort i życzymy udanej gry!</p>
            </section>


            {showScrollButton && (
                <button
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className={styles.backToTopButton}
                    aria-label="Powrót na górę"
                >
                    ↑
                </button>
            )}

        </div>
    );
};

export default Instructions;
